import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {BaseComponent} from "../../../../shared/base.component";
import {ModelID} from "../../../../_typing/generic-types";
import {FieldMap, Option, Rule} from "../../../../_typing/query-builder";
import {SelectFilterComponent} from "../../../select-filter/select-filter.component";



@Component({
    selector: 'validation-field-option',
    templateUrl: './validation-field-option.component.html',
    imports: [
    SelectFilterComponent
],
    styleUrls: ['./validation-field-option.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ValidationFieldOptionComponent extends BaseComponent {
    @Input() modelTypeId: ModelID;
    @Input() rule: Rule;
    @Input() value: string;
    @Input() readonly fields: FieldMap;
    @Output() selectedFieldChanged: EventEmitter<string> = new EventEmitter();

    fieldOptions: Option[];

    constructor() {
        super();
    }

    ngOnInit() {
        //For now only allow validation on datetime
        this.fieldOptions = Object.values(this.fields)?.filter(f=>f.type==='datetime')?.map(f => {
            return {name: f.name, value: f.value};
        });
    }

    setSelectedField(event: string): any {
        this.selectedFieldChanged.next(event);
    }

}
